import { Box, Typography } from "@mui/material";

const SingleDataCard = ({ cardHeading, count, bg, cardbg, Icon, iconColor }) => {
  return (
    <Box
      sx={{
        backgroundColor: cardbg || "#FFFFFF",
        borderRadius: 2,
        p: 2,
        minWidth: 280,
        display: "flex",
        alignItems: "center",
        gap: 2,
      }}
    >
      {Icon && (
        <Box
          sx={{
            width: 69,
            height: 69,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: bg || "#F5F7FF",
          }}
        >
          <Icon sx={{ fontSize: 38, color: iconColor || "#4F46E5" }} />
        </Box>
      )}

      <Box>
        <Typography sx={{ fontSize: 14, color: "#8C8C8C" }}>
          {cardHeading}
        </Typography>
        <Typography sx={{ fontSize: 28, fontWeight: 700, color: "#2B3674" }}>
          {count ?? "--"}
        </Typography>
      </Box>
    </Box>
  );
};

export default SingleDataCard;
